import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 40, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, ease: EASE, delay }}
    {...rest}
  >
    {children}
  </motion.div>
);

const lineVariants = {
  hidden: { y: "105%" },
  show: (d) => ({ y: "0%", transition: { duration: 1.1, ease: EASE, delay: d } }),
};

export const MaskLines = ({ lines, className = "", lineClass = "", delay = 0, onMount = false }) => {
  const trigger = onMount
    ? { animate: "show" }
    : { whileInView: "show", viewport: { once: true, amount: 0.1 } };
  return (
    <motion.span className={`block ${className}`} initial="hidden" {...trigger}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em]">
          <motion.span className={`block ${lineClass}`} variants={lineVariants} custom={delay + i * 0.12}>
            {line}
          </motion.span>
        </span>
      ))}
    </motion.span>
  );
};

export const SectionEyebrow = ({ index, label, light = false, indexClass = "text-go" }) => (
  <div className={`flex items-center gap-3 font-mono text-xs uppercase tracking-[0.22em] ${light ? "text-zinc-300" : "text-zinc-700"}`}>
    <span className={`${indexClass} font-bold`}>{index}</span>
    <span className={`h-px w-10 ${light ? "bg-zinc-600" : "bg-current opacity-30"}`} />
    <span>{label}</span>
  </div>
);
